import { useEffect, useState, useCallback } from "react";
import { useSearchParams } from "react-router-dom";
import { setUserClickData } from "../utility/setUserClickData";

export default function useUserEvent() {
  const [params] = useSearchParams();

  const [trackingData, setTrackingData] = useState({
    source: "",
    utmSource: "",
    utmMedium: "",
    utmTerm: "",
    affId: "",
    leadId: "",
  });

  // Load params only once
  useEffect(() => {
    setTrackingData({
      source: params.get("source") || "",
      utmSource: params.get("utm_source") || "",
      utmMedium: params.get("utm_medium") || "",
      utmTerm: params.get("utm_term") || "",
      affId: params.get("aff_id") || "",
      leadId: params.get("lid") || "",
    });
  }, [params]);

  // Wrapper function that calls YOUR API function
  const trackUserEvent = useCallback(
    (eventName, userId) => {
      setUserClickData({
        event_name: eventName,
        user_id: userId || "unknown",

        // Auto-injected tracking fields
        affiliate_id: trackingData.affId || "No Aff_id found",
        utm_source: trackingData.utmSource || trackingData.utmMedium,
        utm_term: trackingData.utmTerm,
        lead_id: trackingData.leadId,
      });
    },
    [trackingData]
  );

  return { trackUserEvent, trackingData };
}
